import { PaymentPlanLineStatus } from "@nemuru-eng/js-api-client";

export const usePaymentPlanProgress = (paymentPlan, currentPaymentPlanLine) => {
  const totalPaid = paymentPlan.lines.reduce(
    (cum, line) => {
      if (line.status === PaymentPlanLineStatus.PAID) {
        return { amount: cum.amount + line.quota.amount, num: cum.num + 1 };
      }
      return cum;
    },
    { amount: 0, num: 0 }
  );

  const totalAmount = paymentPlan.lines.reduce(
    (cum, line) => cum + line.quota.amount,
    0
  );

  const remainingAmount = totalAmount - totalPaid.amount;

  return {
    totalPaidNumber: totalPaid.num,
    totalPaidAmount: totalPaid.amount,
    remainingAmount,
    totalAmount,
  };
};
